import { render, staticRenderFns } from "./_chartOfAccounts.vue?vue&type=template&id=5ae2b0c8&scoped=true&"
import script from "./_chartOfAccounts.vue?vue&type=script&lang=js&"
export * from "./_chartOfAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae2b0c8",
  null
  
)

export default component.exports